module.exports = __webpack_public_path__ + "img/icons8-list-zfb.1cfda23e.svg";